import { Component, HostListener } from '@angular/core';
import { RemoteControlService } from './remote.service';

@Component({
  selector: 'remote-control',
  template: ``
})
export class RemoteControlComponent {

  constructor(
    private remoteService: RemoteControlService
  ) { }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent | undefined): void {
    if (!event) return;
    this.remoteService.keyPressed(event.key, event.keyCode);
  }
}
